export enum IntegracaoStatus {
  PENDENTE = 'PENDENTE',
  SINCRONIZADO = 'SINCRONIZADO',
  ERRO = 'ERRO'
}
